import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {StyledButton, StyledCard, StyledTag} from "./ReceivedRequest.styled";
import {Button, Col, Flex, Row, Tag} from "antd";
import style from "./ReceivedRequest.module.scss";
import {RequestCardProps} from "../../models";
import {RiShieldCheckFill, RiShieldCheckLine} from "react-icons/ri";
import { FaAnglesDown } from 'react-icons/fa6';
import {FaAngleDown, FaAngleUp} from "react-icons/fa";
import TextArea from "antd/es/input/TextArea";
import moment from "jalali-moment";
import {useParams} from "react-router-dom";
import BorrowRequestPopup from "../borrowRequestPoup/BorrowRequestPopup";


const ReceivedRequestCard = ({data,onCardClickHandle}: RequestCardProps) => {
    const { requestId } = useParams();
    useEffect(() => {
        if (data.id === requestId) onCardClickHandle(data)
    }, [data]);
    const BaseURL = process.env.REACT_APP_IMAGES_URL;
    let status = data?.borrowStatus?.id;

    return (
        <StyledCard bordered={false} onClick={() => onCardClickHandle(data)}>
          <Flex gap={"small"} vertical>
              <Flex align={"center"} justify={"space-between"}>
                  <Col xs={7} sm={7} md={6} lg={6} xl={6}>
                      {
                          data?.product?.productImages?.length > 0 ?
                              <img className={style.customImg} alt={data?.product?.name} loading={"lazy"} src={`${BaseURL}/${data?.product?.productImages[0]?.url}`}
                                   width={23} height={15}/>
                              : <img className={style.customImg} src={require("assets/Logo/emptyImage.png")}/>
                      }
                  </Col>
                  <Col xs={16} sm={16} md={17} lg={17} xl={17}>
                      <Flex gap={"small"} vertical justify={"space-between"} >
                          <Flex justify={"space-between"} align={"center"}>
                              <span className={style.requestDetailTitle}>{data?.product?.name}</span>
                              <span className={(status === 2 || status === 4 ? style.approvedStatus : status === 1
                              ? style.price : style.rejectedStatus
                              )}>{data?.borrowStatus?.description}</span>
                          </Flex>


                          <Flex justify={"space-between"} align={"end"}>
                              <Flex vertical gap={"small"}>
                                  <span className={style.requestDetailText}>از تاریخ <StyledTag>{moment(data.startDate).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</StyledTag></span>
                                  <span className={style.requestDetailText}>تا تاریخ <StyledTag>{moment(data.endDate).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</StyledTag></span>
                              </Flex>
                              <Flex>
                                  <span
                                      className={style.requestDetailText}>{data?.isReceived ? "دریافتی" : "ارسالی"}</span>

                              </Flex>
                          </Flex>
                      </Flex>
                  </Col>
              </Flex>
              {/*{isExpanded &&<Flex vertical gap={"small"}>*/}
              {/*    <span> توضیحات : {data?.borrowerDescription}</span>*/}
              {/*    <TextArea onClick={(event) => event.stopPropagation()} rows={3} placeholder={'توضیحات در صورت نیاز'}/>*/}
              {/*    <Flex justify={"center"} gap={"small"}>*/}
              {/*        <StyledButton onClick={(event) => event.stopPropagation()} block size={"middle"} type={"primary"}>تایید</StyledButton>*/}
              {/*        <StyledButton onClick={(event) => event.stopPropagation()} block size={"middle"}>رد کردن</StyledButton>*/}
              {/*    </Flex>*/}
              {/*</Flex>}*/}
          </Flex>
        </StyledCard>
    );
};

export default connect(null, {})(
    withRouter(ReceivedRequestCard)
);
